<fo-side-panel
  [title]="'createEquipment' | i18nextCap"
  [nested]="inputs.nested"
  [backAriaLabel]="'goBack' | i18nextCap"
  [closeAriaLabel]="'close' | i18nextCap"
  (closed)="inputs.onCancel()"
>
  <fo-create-equipment-panel
    #panel
    [companyId]="inputs.companyId"
    [lockCompany]="inputs.lockCompany ?? false"
    [actionType]="inputs.actionType"
    (created)="inputs.onSave($event)"
  />
  @if (!panel.choosingType) {
    <div class="footer" panel-footer>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!panel.canCreate"
        (click)="panel.create()"
      >
        {{ 'forms:create' | i18nextCap }}
      </button>
    </div>
  }
</fo-side-panel>
